const dayInterval1List = ['1', '2', '3', '4', '5', '6', '10', '20']
const weekInterval1List = ['1', '2', '3', '4', '5', '6', '8', '10', '20']
const monthIntervalF2List = ['1', '2', '3', '4', '5', '6', '12', '18']
const monthIntervalT3List = ['1', '2', '3', '4', '5', '6', '12', '18']
const daysOfMonthList = [
  { value: '1', text: '1st' },
  { value: '2', text: '2nd' },
  { value: '3', text: '3rd' },
  { value: '4', text: '4th' },
  { value: '5', text: '5th' },
  { value: '6', text: '6th' },
  { value: '7', text: '7th' },
  { value: '8', text: '8th' },
  { value: '9', text: '9th' },
  { value: '10', text: '10th' },
  { value: '11', text: '11th' },
  { value: '12', text: '12th' },
  { value: '13', text: '13th' },
  { value: '14', text: '14th' },
  { value: '15', text: '15th' },
  { value: '16', text: '16th' },
  { value: '17', text: '17th' },
  { value: '18', text: '18th' },
  { value: '19', text: '19th' },
  { value: '20', text: '20th' },
  { value: '21', text: '21st' },
  { value: '22', text: '22nd' },
  { value: '23', text: '23rd' },
  { value: '24', text: '24th' },
  { value: '25', text: '25th' },
  { value: '26', text: '26th' },
  { value: '27', text: '27th' },
  { value: '28', text: '28th' },
  { value: '29', text: '29th' },
  { value: '30', text: '30th' }
]

const toOrdinal = n =>
  (n += ['st', 'nd', 'rd'][(n % 100 >> 3) ^ 1 && n % 10] || 'th')

const weeksOfMonthList = [
  { value: '1', text: 'first' },
  { value: '2', text: 'second' },
  { value: '3', text: 'third' },
  { value: '4', text: 'fourth' },
  { value: '0', text: 'last' }
]
const daysOfWeekList = [
  { value: '0', text: 'Sunday' },
  { value: '1', text: 'Monday' },
  { value: '2', text: 'Tuesday' },
  { value: '3', text: 'Wednesday' },
  { value: '4', text: 'Thursday' },
  { value: '5', text: 'Friday' },
  { value: '6', text: 'Saturday' }
]
const monthList = [
  { value: '1', text: 'January' },
  { value: '2', text: 'February' },
  { value: '3', text: 'March' },
  { value: '4', text: 'April' },
  { value: '5', text: 'May' },
  { value: '6', text: 'June' },
  { value: '7', text: 'July' },
  { value: '8', text: 'August' },
  { value: '9', text: 'September' },
  { value: '10', text: 'October' },
  { value: '11', text: 'November' },
  { value: '12', text: 'December' }
]

// TODO: some of these lists need to be localized
const selectLists = {
  DayInterval1: dayInterval1List,
  WeekInterval1: weekInterval1List,
  MonthIntervalF2: monthIntervalF2List,
  MonthIntervalT3: monthIntervalT3List,
  DaysOfMonth: daysOfMonthList,
  WeeksOfMonth: weeksOfMonthList,
  DaysOfWeek: daysOfWeekList,
  Months: monthList
}

export { selectLists, toOrdinal }
